import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import WLogo from "../../assets/W-Logo.png";
import $ from "jquery";
import { StateContext } from "../../store/StateProvider";

const Sidebar = () => {
  const [state, dispatch] = StateContext();
  const OpenSidebarHandler = (e) => {
    e.preventDefault();
    $(".SideBar").css("transform", "translateX(0%)");
  };
  const CloseHandler = (e) => {
    e.preventDefault();
    $(".SideBar").css("transform", "translateX(-100%)");
  };
  window.addEventListener("resize", () => {
    if (window.innerWidth > 768) {
      $(".SideBar").css("transform", "translateX(0%)");
    } else if (window.innerWidth < 768) {
      $(".SideBar").css("transform", "translateX(-100%)");
    }
  });
  //
  React.useEffect(() => {
    var SIdebar1Li = $(".SideBarUL-1 > li");
    var Path = window.location.pathname;
    const lastItem = Path.substring(Path.lastIndexOf("/") + 1);
    let vd;
    if (lastItem === "creator") {
      vd = SIdebar1Li[2];
      $(vd).addClass("LinkActive");
    } else if (lastItem === "portfolio") {
      vd = SIdebar1Li[3];
      $(vd).addClass("LinkActive");
    } else if (lastItem === "creator1") {
      vd = SIdebar1Li[4];
      $(vd).addClass("LinkActive");
    }
  }, []);
  return (
    <div className="col-md-1 px-0">
      <div className="LeftBarIcon">
        <a href="/" onClick={OpenSidebarHandler}>
          <i className="fa fa-bars" aria-hidden="true"></i>
        </a>
      </div>
      <div className="SideBar">
        <ul className="SideBarUL-1">
          <li className="LeftBar">
            <a href="/" onClick={CloseHandler}>
              <i className="fa fa-bars" aria-hidden="true"></i>
            </a>
          </li>
          <li>
            <NavLink to={`/`}>
              <img src={WLogo} className="img-fluid" alt="" />
            </NavLink>
          </li>
          <li className="Link1 ">
            <NavLink to={`/creator`}>
              <img src={state.items.Circle} className="img-fluid" alt="" />
            </NavLink>
          </li>
          <li className="Link1 ">
            <NavLink to={`/portfolio`}>
              <img src={state.items.AlienNot} className="img-fluid" alt="" />
            </NavLink>
          </li>
          <li className="Link1 ">
            <NavLink to={`/creator/creator1`}>
              <img src={state.items.Bag} className="img-fluid" alt="" />
            </NavLink>
          </li>
        </ul>
        <ul className="SideBarUL-2">
          <li className="Link1 ">
            <NavLink to={``}>
              <img src={state.items.Porfile} className="img-fluid" alt="" />
            </NavLink>
          </li>
          <li className="Link1 ">
            <NavLink to={``}>
              <img src={state.items.CoyPaste} className="img-fluid" alt="" />
            </NavLink>
            {/* <a href="/creator" onClick={ChangeRootVarHandler}></a> */}
            {/* <NavLink to={`/activity`}></NavLink> */}
          </li>
          <li className="Link1 ">
            <NavLink to={``}>
              <img src={state.items.Dismond} className="img-fluid" alt="" />
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
